// ======================================================================
// FILE:
// src/modules/service_crm/reports/services/reportService.js
//
// MODULE:
// Service CRM
//
// FEATURE:
// Reports APIs
//
// PHASE 1
// - Service Ticket Report
//
// FUTURE
// - Feedback Report
// - Satisfaction Report
// - Installed Product Report
// - Excel Export
// - PDF Export
// ======================================================================

import axiosClient from "../../../../api/axiosClient";


// ======================================================================
// SERVICE TICKET REPORT
// ======================================================================

const getTicketReport = async (
  params = {}
) => {

  const res =
    await axiosClient.get(

      "/api/service-crm/reports/tickets",

      {
        params,
      }

    );

  return (
    res.data.data
  );

};


// ======================================================================
// EXPORT EXCEL
// ======================================================================

const exportTicketReportExcel =
  async (params = {}) => {

    const res =
      await axiosClient.get(

        "/api/service-crm/reports/tickets/excel",

        {

          params,

          responseType:
            "blob",

        }

      );

    return res.data;

  };


// ======================================================================
// EXPORT PDF
// ======================================================================

const exportTicketReportPdf =
  async (params = {}) => {

    const res =
      await axiosClient.get(

        "/api/service-crm/reports/tickets/pdf",

        {

          params,

          responseType:
            "blob",

        }

      );

    return res.data;

  };
// ======================================================================
// INSTALLED PRODUCT REPORT
// ======================================================================

const getInstalledProductReport = async (
  params = {}
) => {

  const res =
    await axiosClient.get(

      "/api/service-crm/reports/installed-products",

      {
        params,
      }

    );

  return (
    res.data.data
  );

};


// ======================================================================
// INSTALLED PRODUCT REPORT EXCEL
// ======================================================================

const exportInstalledProductReportExcel =
  async (params = {}) => {

    const res =
      await axiosClient.get(

        "/api/service-crm/reports/installed-products/excel",

        {

          params,

          responseType:
            "blob",

        }

      );

    return res.data;

  };
  // ======================================================================
// SATISFACTION ANALYSIS REPORT
// ======================================================================

const getSatisfactionAnalysisReport =
  async (params = {}) => {

    const res =
      await axiosClient.get(

        "/api/service-crm/reports/satisfaction",

        {
          params,
        }

      );

    return (
      res.data.data
    );

  };


// ======================================================================
// SATISFACTION ANALYSIS EXCEL
// ======================================================================

const exportSatisfactionAnalysisExcel =
  async (params = {}) => {

    const res =
      await axiosClient.get(

        "/api/service-crm/reports/satisfaction/excel",

        {

          params,

          responseType:
            "blob",

        }

      );

    return res.data;

  };

// ======================================================================
// FEEDBACK REPORT
// ======================================================================

const getFeedbackReport =
  async (params = {}) => {

    const res =
      await axiosClient.get(

        "/api/service-crm/reports/feedback",

        {
          params,
        }

      );

    return (
      res.data.data
    );

  };


// ======================================================================
// FEEDBACK REPORT EXCEL
// ======================================================================

const exportFeedbackReportExcel =
  async (params = {}) => {

    const res =
      await axiosClient.get(

        "/api/service-crm/reports/feedback/excel",

        {

          params,

          responseType:
            "blob",

        }

      );

    return res.data;

  };

  // ======================================================================
// EXPORT
// ======================================================================

const reportService = {

  getTicketReport,

  exportTicketReportExcel,

  exportTicketReportPdf,

  getInstalledProductReport,

  exportInstalledProductReportExcel,

  getSatisfactionAnalysisReport,
  exportSatisfactionAnalysisExcel,

  getFeedbackReport,

  exportFeedbackReportExcel,
};



export default reportService;
